import Vue from "vue";
import grocerymain from "./components/_grocerymain";
import SubmitEvent = JQuery.SubmitEvent;
import HtmlElementHelper from '../../Shared/Helpers/htmlElementHelper';

document.addEventListener('DOMContentLoaded', function () {
    const createGroceryArticlesPage = function () {

        new Vue({
            el: '#app',
            template: "#page-content",
            components: {
                'grocery-main': grocerymain,
            },
            data: {
                articleId: -1,
                errors: {
                    articleId: false
                }
            },
            computed: {
                openedTab() {
                    return new URL(location.href).searchParams.get('tab');
                },
                openedId() {
                    return new URL(location.href).searchParams.get('sku');
                },
                articleIdUrl() {
                    return new URL(location.href).searchParams.get('articleId');
                }
            },
            methods: {
                submitDataForm(event: SubmitEvent): Boolean {

                    const isQuickRegistrationRequired = event.currentTarget.getAttribute("data-quickreg") == "True";
                    const articleId = event.currentTarget.getAttribute("data-article-id");

                    if (isQuickRegistrationRequired) {
                        (window as any).bindQuickRegModal(event);
                        event.preventDefault();
                        return false;
                    }

                    if (!this._validateArticleId(articleId)) {
                        event.preventDefault();
                        return false;
                    }

                    this.articleId = articleId;

                    this.$nextTick(() => {
                        this.$refs.form.submit();
                    });
                },
                _validateArticleId(articleId: number): Boolean {
                    this.errors.articleId = articleId == null || articleId == -1;
                    return !this.errors.articleId;
                }
            },
        });
    }

    if (HtmlElementHelper.g_elementExists('app')) {
        createGroceryArticlesPage();
    }
});